// TypeChip — categorical "Recurring / One-off / Occurrence / Orphan"
// label per brand skill §9.5. Distinct from TrackingStatusBadge: a
// TypeChip is a taxonomic marker (it's a what, not a how-is-it-
// going), so the palette is slate-only for the neutral variants. The
// `orphan` variant is the explicit exception — an amber tint + a
// Lucide AlertTriangle flags the data inconsistency without
// shouting like a status badge. Lives in /shared/ because
// obligations and insurances may reuse it later.

import { AlertTriangle } from "lucide-react";

export type TypeChipKind = "recurring" | "one-off" | "occurrence" | "orphan";

export interface TypeChipProps {
  type: TypeChipKind;
}

const LABELS: Record<TypeChipKind, string> = {
  recurring: "Recurring",
  "one-off": "One-off",
  occurrence: "Occurrence",
  orphan: "Orphan",
};

const NEUTRAL_CLASS =
  "bg-slate-100 text-slate-600 dark:bg-slate-700/60 dark:text-slate-400";

const ORPHAN_CLASS =
  "bg-amber-50 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300";

export default function TypeChip({ type }: TypeChipProps) {
  const tone = type === "orphan" ? ORPHAN_CLASS : NEUTRAL_CLASS;
  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-lg px-1.5 py-0.5 text-[10px] font-medium ${tone}`}
    >
      {type === "orphan" && (
        <AlertTriangle aria-hidden="true" className="h-3 w-3" />
      )}
      {LABELS[type]}
    </span>
  );
}
